/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Injectable } from '@angular/core';
import { File } from 'src/app/models/file-sharing';

/**
 * Currently all disposable code. Uses an in-memory model to simulate a back end.
 */
@Injectable({
  providedIn: 'root'
})
export class FileSharingServiceService {
  getFile(name: string): File {
    return this.files.find((f) => f.name === name);
  }

  getChildren(name: string): File[] {
    const file = this.getFile(name);
    const children = [];
    for (const c of file.children) {
      children.push(this.getFile(c));
    }
    return children;
  }

  getDefaultFile(): File {
    return this.files[1];
  }

  private readonly files: File[] = [
    {
      name: '',
      path: '/',
      isDirectory: true,
      children: ['Support'],
      size: 0,
      url: 'https://0.0.0.0:999999/nonexistent',
      modified: new Date(2021, 1, 1, 1, 1, 1, 1),
      favorite: false,
      selected: false
    },
    {
      name: 'Support',
      path: '/Support',
      isDirectory: true,
      children: ['my_uploads', 'windriver_uploads', 'File_Sharing_Help.pdf'],
      size: 0,
      url: 'https://0.0.0.0:999999/nonexistent',
      modified: new Date(2021, 2, 2, 2, 2, 2, 2),
      favorite: false,
      selected: false
    },
    {
      name: 'my_uploads',
      path: '/Support/my_uploads',
      isDirectory: true,
      children: [],
      size: 0,
      url: 'https://0.0.0.0:999999/nonexistent',
      modified: new Date(2021, 3, 3, 3, 3, 3, 3),
      favorite: false,
      selected: false
    },
    {
      name: 'windriver_uploads',
      path: '/Support/windriver_uploads',
      isDirectory: true,
      children: [],
      size: 0,
      url: 'https://0.0.0.0:999999/nonexistent',
      modified: new Date(2021, 4, 4, 4, 4, 4, 4),
      favorite: false,
      selected: false
    },
    {
      name: 'File_Sharing_Help.pdf',
      path: '/Support/File_Sharing_Help.pdf',
      isDirectory: false,
      children: [],
      size: 61613,
      url: 'https://0.0.0.0:999999/nonexistent',
      modified: new Date(2021, 5, 5, 5, 5, 5, 5),
      favorite: false,
      selected: false
    }
  ];
}
